var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0003 4.00002C17.4318 4.00002 4.00033 17.4315 4.00033 34C4.00033 50.5686 17.4318 64 34.0003 64C50.5689 64 64.0003 50.5686 64.0003 34C64.0003 17.4315 50.5689 4.00002 34.0003 4.00002ZM0.666992 34C0.666992 15.5905 15.5908 0.666687 34.0003 0.666687C52.4098 0.666687 67.3337 15.5905 67.3337 34C67.3337 52.4095 52.4098 67.3334 34.0003 67.3334C15.5908 67.3334 0.666992 52.4095 0.666992 34Z",
    fill: "#222D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6435 34L18.722 46.9215L21.079 49.2785L34.0005 36.357L47.022 49.3785L49.379 47.0215L36.3575 34L49.379 20.9785L47.022 18.6215L34.0005 31.643L21.079 18.7215L18.722 21.0785L31.6435 34Z",
    fill: "#222D34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutline);
export default __webpack_public_path__ + "static/media/close-outline.52b15f1d.svg";
export { ForwardRef as ReactComponent };